var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6 23.2H17.2V18.4C17.2 16.2672 18.8 15.2 20.3992 15.2H20.4008C22 15.2 23.6 16.2672 23.6 18.4V23.2ZM21.2 25.6C21.2 26.0416 20.8416 26.4 20.4 26.4C19.9584 26.4 19.6 26.0416 19.6 25.6V24.8H21.2V25.6ZM26 23.2H25.2V18.4C25.2 15.5576 23.3056 13.98 21.2 13.6632V12H19.6V13.6632C17.4944 13.98 15.6 15.5576 15.6 18.4V23.2H14.8C14.3584 23.2 14 23.5584 14 24C14 24.4416 14.3584 24.8 14.8 24.8H18V25.6C18 26.9256 19.0744 28 20.4 28C21.7256 28 22.8 26.9256 22.8 25.6V24.8H26C26.4416 24.8 26.8 24.4416 26.8 24C26.8 23.5584 26.4416 23.2 26 23.2Z",
    fill: "#8A9099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 18C29.7614 18 32 15.7614 32 13C32 10.2386 29.7614 8 27 8C24.2386 8 22 10.2386 22 13C22 15.7614 24.2386 18 27 18Z",
    fill: "#F68424",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification2);
export default __webpack_public_path__ + "static/media/notification2.37f2ba2e537417375e08f489e6c5794c.svg";
export { ForwardRef as ReactComponent };